<nav class="col-2 ps-0 pl-sm-2 bg-light sidebar">
  <ul class="nav flex-column">
    <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
      <i class="fa fa-bars"></i>
    </h6>
    @for (item of items; track item) {
      <li class="nav-item" [ngClass]="{ 'disabled': current === item.link, 'cursor-default': item.link === '' }">
        @if (item.link === '') {
          <hr class="my-2">
        }
        @if (item.link && item.link.startsWith('http')) {
          <a class="nav-link" [href]="item.link" target="_blank">
            <i [ngClass]="'fa fa-' + item.icon"></i> <span class="d-none d-lg-inline">{{item.name}}</span>
          </a>
        }
        @if (item.link && !item.link.startsWith('http')) {
          <a class="nav-link" (click)="changeContent(item.link)">
            <i [ngClass]="'fa fa-' + item.icon"></i> <span class="d-none d-lg-inline">{{item.name}}</span>
          </a>
        }
      </li>
    }
  </ul>
</nav>